<template>
  <div>
    <div class="d-flex justify-center">
      <div class="_temp_list">
        <div v-if="loading">
          <v-skeleton-loader
            type="list-item-avatar"
            class="mb-3"
          ></v-skeleton-loader>
          <v-skeleton-loader type="image"></v-skeleton-loader>
        </div>
        <div v-if="dataSet">
          <v-card
            v-if="
              role == 'SUPERADMIN' ||
              role == 'TF' ||
              permissions.includes('MENTOR') ||
              role == 'SCHOLAR'
            "
            class="rounded_max d-flex pa-3 mb-3"
            elevation="1"
          >
            <v-avatar size="35" class="mr-3">
              <img
                :src="profile.profile_picture ? profile.profile_picture : ava"
                class="obj_fit"
                alt="isyan"
              />
            </v-avatar>
            <div style="width: 100%">
              <v-btn
                rounded
                depressed
                block
                @click="createThread"
                class="d-flex justify-start grey--text text-capitalize"
                ><v-icon class="mr-2">mdi-pencil-box-outline</v-icon> Write New
                Thread</v-btn
              >
            </div>
          </v-card>

          <div v-if="dataSet.length">
            <v-card
              class="rounded-lg mb-3"
              style="overflow: hidden"
              elevation="1"
              v-for="(item, i) in dataSet"
              :key="i"
              :to="`/thread-mentor/inclass/${$route.params.idCourse}/${item.id}`"
            >
              <router-link
                class="opener_name d-flex pa-3"
                :to="
                  item.data_author.role === 'SCHOLAR'
                    ? `/scholar/${item.data_author.id}`
                    : ''
                "
              >
                <v-avatar class="mr-3">
                  <img
                    :src="
                      item.data_author.profile_picture
                        ? item.data_author.profile_picture
                        : ava
                    "
                    class="obj_fit"
                    alt=""
                  />
                </v-avatar>
                <div>
                  <h4>{{ item.data_author.name }}</h4>
                  <small class="grey--text">{{
                    $date(item.created_at).fromNow()
                  }}</small>
                </div>
              </router-link>
              <section class="px-5">
                <h3>{{ item.title }}</h3>
              </section>
              <v-img
                v-if="item.thumbnail"
                :src="item.thumbnail"
                height="250"
                class="obj_fit"
              ></v-img>
              <v-card-actions class="pa-0 d-flex justify-end">
                <v-btn text color="blue">
                  <v-icon>mdi-comment</v-icon>
                  {{ item.data_comment.length }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </div>
          <div v-if="!dataSet.length">
            <v-card
              class="rounded-lg mb-3 d-flex align-center justify-center flex-column"
              style="overflow: hidden"
              elevation="1"
            >
              <img
                src="../../../../assets/img/gundam/no_comment.png"
                height="150px"
                alt=""
              />
              <b class="default_txt my-3">
                You can share your thought. Let others give some opinions about
                it.</b
              >
            </v-card>
          </div>
        </div>
        <div class="pa-2">
          <dialog-large
            :d_large="d_large"
            @close="d_large = false"
            @refetch="fetchData"
            :type="d_type"
            :title="d_title"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
// import dialogLarge from "../../../dialog/dialogLarge.vue";
export default {
  // components: { dialogLarge },
  name: "listForumMentor",
  data() {
    return {
      d_create: false,
      d_large: false,
      d_type: "cm_thread",
      d_title: "",
      inventory: null,
      dataSet: null,
      loading: false,
      total: null,
      last_page: null,
      find: "",
      limit: 10,
      page: 1,
    };
  },
  computed: {
    ...mapState({
      ava: (state) => state.ava,
      profile: (state) => state.profile,
      role: (state) => state.role,
      permissions: (state) => state.permissions,
    }),
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      let data = {
        path: `forum/administrator/${this.$route.params.idCourse}?type=mentor&filter[status]=1&page[size]=${this.limit}&page[number]=${this.page}&sort=-created_at`,
      };
      this.$store.dispatch("course/getData", data).then((data) => {
        this.loading = false;
        this.dataSet = data.data;
        this.total = data.total;
        this.last_page = data.last_page;
      });
    },
    createThread() {
      this.d_type = "cm_thread";
      this.d_large = true;
      this.d_title = "Write New Thread";
    },
  },
};
</script>

<style></style>
